import React, {useEffect, 
               useState, 
               useContext}          from 'react';
import {Container, Card, Row, Col}  from 'react-bootstrap';
import api                          from './AxiosConfig';
import { BsFillCaretDownFill,
         BsFillCaretUpFill}         from "react-icons/bs";
import { SelectionContext }         from './SelectionContext';
import ChecklistSummaryItem         from './ChecklistSummaryItem';

function ChecklistSummary( ) {
  const [checklists, setChecklists] = useState();
  const { getExpandedCLSummary, 
          toggleExpandedCLSummary}  = useContext(SelectionContext);
         

  useEffect(() => {
       async function getCheckListItems() {
            try {
                const response = await api.get(`/site/checklists/all`, {withCredentials: true });
                setChecklists(response.data);
            } catch (error) {
                console.log("getMasterGoal: " + error);
            }
        }
        getCheckListItems();
 }, []);
           
 const handleExpand = () => {
     console.log("handleExpanded");
     toggleExpandedCLSummary();
 }
         
 return (
    <Container>
      <Row className="justify-content-md-center">
        <Col>
          <Card className={'mt-2 mb-1 card-goal-type-cl-summary'}>
            <Card.Header className="card-goal-header">
              <div class="content-container">
                <div class="left-content d-flex align-items-center">
                  <span>Checklist Summary</span>
                </div>
                <div class="right-content">
                  { getExpandedCLSummary() === true ? (<BsFillCaretUpFill onClick={() => handleExpand()}/>) : (<BsFillCaretDownFill onClick={() => handleExpand()}/>) }
                </div>
              </div>
            </Card.Header>
          { checklists ? (
            <Card.Body className="p-0">
                   { checklists.map((cl, index) => (
                     <ChecklistSummaryItem key={index} clItem={cl} expanded={getExpandedCLSummary()}/>
               ))}
             </Card.Body>
              ) : ( <p>Loading...</p> ) }
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ChecklistSummary;
